import { render, staticRenderFns } from "./ChatContact.vue?vue&type=template&id=ee16b7b8&scoped=true"
import script from "./ChatContact.vue?vue&type=script&lang=js"
export * from "./ChatContact.vue?vue&type=script&lang=js"
import style0 from "./ChatContact.vue?vue&type=style&index=0&id=ee16b7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee16b7b8",
  null
  
)

export default component.exports